import { render, staticRenderFns } from "./Register3.vue?vue&type=template&id=7cf03b6b&scoped=true"
import script from "./Register3.vue?vue&type=script&lang=ts"
export * from "./Register3.vue?vue&type=script&lang=ts"
import style0 from "./Register3.vue?vue&type=style&index=0&id=7cf03b6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf03b6b",
  null
  
)

export default component.exports